export function sugerirTroco(valor) {
  const sugestoes = new Set();

  // Extrai o primeiro e segundo número da direita para a esquerda, ignorando decimais
  const valorStr = Math.floor(valor).toString();
  const ultimosDois = parseInt(valorStr.slice(-2)) || 0;

  // Adiciona troco de 70 se ultimosDois estiver entre 51 e 70
  if (ultimosDois >= 51 && ultimosDois <= 70) {
    sugestoes.add(70);
  }

  // Arredonda para múltiplos de 5 até 100
  const notas = [5, 10, 20, 50, 100];

  notas.forEach(nota => {
    const arredondado = Math.ceil(valor / nota) * nota;
    if (arredondado > valor) {
      sugestoes.add(arredondado);
    }
  });

  return Array.from(sugestoes).sort((a, b) => a - b).slice(0, 10);
}